// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_linhaTitulo__Wd5Xj {
  border-bottom: 0.1rem solid #0f2047 !important;
  margin-left: 40px !important;
  width: 80px !important;
  margin-top: -16px !important;
}

.styles_linhaTituloPopup__1Afos {
  border-bottom: 0.2rem solid #0f2047 !important;
  margin-left: 40px !important;
  width: 80px !important;
  margin-top: 0px !important;
  padding-top: 0px !important;
}

.styles_tituloContainer__TbUk4 {
  display: flex !important;
  align-items: center !important;
  margin-left: 40px !important;
  margin-top: -28px !important;
}

.styles_titulo__jO5hx {
  font-size: 44px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
}

.styles_iconeTitulo__3uUoz {
  font-size: 40px !important;
  color: #0f2047 !important;
  margin-left: 12px !important;
  margin-right: 12px !important;
  margin-top: -8px !important;
}

.styles_iconeTituloPopup__QXc8C {
  font-size: 40px !important;
  color: #0f2047 !important;
  margin-top: -8px !important;
}

.styles_botaoContainer__YgqPA {
  display: flex !important;
  align-items: center !important;
  margin-left: 40px !important;
}

.styles_botaoNovo__gcdqR {
  width: 120px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
  margin-top: 12px !important;
  margin-left: 20% !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  text-transform: capitalize !important;
  height: 36px !important;
}

.styles_botaoNovo__gcdqR:hover {
  transform: scale(0.95) !important;
}

.styles_tituloPopup__H9moY {
  font-size: 28px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
  margin: 8px;
}

.styles_tituloPopupContainer__iLUrJ {
  display: flex !important;
  align-items: center !important;
}

.styles_botoesPopupGeral__7mG4c {
  margin-bottom: 20px !important;
  margin-right: 20px !important;
}

.styles_botaoPopupSalvar__qzgky {
  width: 180px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.styles_botaoPopupSalvar__qzgky:hover {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelar__iU0ng {
  width: 180px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
}

.styles_botaoPopupCancelar__iU0ng:hover {
  transform: scale(0.95) !important;
}

.styles_txtBuscaTabela__kgVKm {
  margin-top: 16px !important;
  margin-left: 16px !important;
}

.styles_iconeBusca__5Ux4P {
  color: #18316e !important;
  font-size: 28px !important;
  margin-top: 16px !important;
}

.styles_textoExclusao__I0HK2 {
  color: #000000 !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
}

.styles_tituloExclusao__qOo8P {
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
  font-size: 44px !important;
}

.styles_botaoPopupExcluir__KwpXp {
  width: 120px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  margin-right: 7%;
  margin-bottom: 4%;
}

.styles_botaoPopupExcluir__KwpXp:hover {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelarExclusao__qQEmf {
  width: 120px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
  margin-right: 4%;
  margin-bottom: 4%;
}

.styles_botaoPopupCancelarExclusao__qQEmf:hover {
  transform: scale(0.95) !important;
}

/* Adicione este trecho de código ao seu arquivo de estilos CSS (por exemplo, styles.module.css) */

.styles_caixaTextoPequena__BY1I7 {
  height: 28px;
  /* Ajuste a altura conforme necessário */
}

.styles_caixaDeTexto__UcJ-W {
  margin: 200px 70 !important;
  height: 30px !important;
}

.styles_botaoVoltar__b-atH {
  background-color: #0f2047;
  color: #ffffff;
  border-color: #ffffff;
  border-width: 1px;
  border-style: solid;
  font-family: "Inter";
  border-radius: 8px;
  transition: all 0.3s ease;
  text-transform: capitalize;
  height: 36px;
}

.styles_botaoVoltar__b-atH:hover {
  background-color: #ffffff;
  color: #0f2047;
}

.styles_inputPequeno__pQfdC {
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  /* Adicione mais estilos conforme necessário */
}

.styles_botaoVoltar__b-atH:hover {
  background-color: #0f2047;
  color: #ffffff;
}

.styles_labelPequeno__tG-G9 {
  font-size: 12px;
  /* Ajuste o valor conforme necessário */
}

.styles_placeholder__9sYhN {
  font-size: 12px;
  /* Ajuste o valor conforme necessário */
  /* Outros estilos do placeholder, se necessário */
}

.styles_popupHeader__zJFpk {
  margin-top: 8px;
  padding-bottom: 0px !important;
}

.styles_popupContent__gxm6T {
  padding-top: 0px;
}

/* Estilização do PDF */

.styles_pdfContainer__ZYhDW {
  background: #ffffff;
  border-radius: 8px;
  padding: .5rem;
}

.styles_pdfHeader__64deM {
  align-items: center;
  color: #18316e !important;
  display: flex;
  justify-content: space-between;
}

.styles_pdfLogo__D35j7{
  width: 15rem;
}

.styles_pdfContent__4eU-8 {
  margin-top: 1rem;
}

.styles_pdfTable__JlZtf {
  border-radius: 8px;
  box-shadow: 2px 2px 5px #C9C9C9;
  text-align: center;
  width: 100%;
}

.styles_pdfTable__JlZtf th {
  background-color: #18316e;
  border-radius: 6px;
  box-sizing: border-box;
  font-size: 1rem;
  color: #FFF;
  padding: 0.2rem 0;
}

.styles_pdfTotal__PnR2x {
  margin-left: .5rem;
  padding: .5rem;
}

.styles_pdfFooterTotal__PIVcE {
  break-inside: avoid;
  page-break-inside: avoid;
}

.styles_pdfButtons__VJwWt{
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: .5rem;
}

.styles_pdfContainer__ZYhDW h4 {
  page-break-before: always;
}

.styles_pdfContainer__ZYhDW table {
  page-break-inside: avoid;
}`, "",{"version":3,"sources":["webpack://./src/pages/Faturamento/styles.module.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,kGAAkG;;AAElG;EACE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;;AAEvB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".linhaTitulo {\n  border-bottom: 0.1rem solid #0f2047 !important;\n  margin-left: 40px !important;\n  width: 80px !important;\n  margin-top: -16px !important;\n}\n\n.linhaTituloPopup {\n  border-bottom: 0.2rem solid #0f2047 !important;\n  margin-left: 40px !important;\n  width: 80px !important;\n  margin-top: 0px !important;\n  padding-top: 0px !important;\n}\n\n.tituloContainer {\n  display: flex !important;\n  align-items: center !important;\n  margin-left: 40px !important;\n  margin-top: -28px !important;\n}\n\n.titulo {\n  font-size: 44px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n}\n\n.iconeTitulo {\n  font-size: 40px !important;\n  color: #0f2047 !important;\n  margin-left: 12px !important;\n  margin-right: 12px !important;\n  margin-top: -8px !important;\n}\n\n.iconeTituloPopup {\n  font-size: 40px !important;\n  color: #0f2047 !important;\n  margin-top: -8px !important;\n}\n\n.botaoContainer {\n  display: flex !important;\n  align-items: center !important;\n  margin-left: 40px !important;\n}\n\n.botaoNovo {\n  width: 120px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n  margin-top: 12px !important;\n  margin-left: 20% !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  text-transform: capitalize !important;\n  height: 36px !important;\n}\n\n.botaoNovo:hover {\n  transform: scale(0.95) !important;\n}\n\n.tituloPopup {\n  font-size: 28px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n  margin: 8px;\n}\n\n.tituloPopupContainer {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.botoesPopupGeral {\n  margin-bottom: 20px !important;\n  margin-right: 20px !important;\n}\n\n.botaoPopupSalvar {\n  width: 180px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n}\n\n.botaoPopupSalvar:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelar {\n  width: 180px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n}\n\n.botaoPopupCancelar:hover {\n  transform: scale(0.95) !important;\n}\n\n.txtBuscaTabela {\n  margin-top: 16px !important;\n  margin-left: 16px !important;\n}\n\n.iconeBusca {\n  color: #18316e !important;\n  font-size: 28px !important;\n  margin-top: 16px !important;\n}\n\n.textoExclusao {\n  color: #000000 !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n}\n\n.tituloExclusao {\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n  font-size: 44px !important;\n}\n\n.botaoPopupExcluir {\n  width: 120px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  margin-right: 7%;\n  margin-bottom: 4%;\n}\n\n.botaoPopupExcluir:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelarExclusao {\n  width: 120px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n  margin-right: 4%;\n  margin-bottom: 4%;\n}\n\n.botaoPopupCancelarExclusao:hover {\n  transform: scale(0.95) !important;\n}\n\n/* Adicione este trecho de código ao seu arquivo de estilos CSS (por exemplo, styles.module.css) */\n\n.caixaTextoPequena {\n  height: 28px;\n  /* Ajuste a altura conforme necessário */\n}\n\n.caixaDeTexto {\n  margin: 200px 70 !important;\n  height: 30px !important;\n}\n\n.botaoVoltar {\n  background-color: #0f2047;\n  color: #ffffff;\n  border-color: #ffffff;\n  border-width: 1px;\n  border-style: solid;\n  font-family: \"Inter\";\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  text-transform: capitalize;\n  height: 36px;\n}\n\n.botaoVoltar:hover {\n  background-color: #ffffff;\n  color: #0f2047;\n}\n\n.inputPequeno {\n  width: 100%;\n  padding: 5px;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  /* Adicione mais estilos conforme necessário */\n}\n\n.botaoVoltar:hover {\n  background-color: #0f2047;\n  color: #ffffff;\n}\n\n.labelPequeno {\n  font-size: 12px;\n  /* Ajuste o valor conforme necessário */\n}\n\n.placeholder {\n  font-size: 12px;\n  /* Ajuste o valor conforme necessário */\n  /* Outros estilos do placeholder, se necessário */\n}\n\n.popupHeader {\n  margin-top: 8px;\n  padding-bottom: 0px !important;\n}\n\n.popupContent {\n  padding-top: 0px;\n}\n\n/* Estilização do PDF */\n\n.pdfContainer {\n  background: #ffffff;\n  border-radius: 8px;\n  padding: .5rem;\n}\n\n.pdfHeader {\n  align-items: center;\n  color: #18316e !important;\n  display: flex;\n  justify-content: space-between;\n}\n\n.pdfLogo{\n  width: 15rem;\n}\n\n.pdfContent {\n  margin-top: 1rem;\n}\n\n.pdfTable {\n  border-radius: 8px;\n  box-shadow: 2px 2px 5px #C9C9C9;\n  text-align: center;\n  width: 100%;\n}\n\n.pdfTable th {\n  background-color: #18316e;\n  border-radius: 6px;\n  box-sizing: border-box;\n  font-size: 1rem;\n  color: #FFF;\n  padding: 0.2rem 0;\n}\n\n.pdfTotal {\n  margin-left: .5rem;\n  padding: .5rem;\n}\n\n.pdfFooterTotal {\n  break-inside: avoid;\n  page-break-inside: avoid;\n}\n\n.pdfButtons{\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding: .5rem;\n}\n\n.pdfContainer h4 {\n  page-break-before: always;\n}\n\n.pdfContainer table {\n  page-break-inside: avoid;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linhaTitulo": `styles_linhaTitulo__Wd5Xj`,
	"linhaTituloPopup": `styles_linhaTituloPopup__1Afos`,
	"tituloContainer": `styles_tituloContainer__TbUk4`,
	"titulo": `styles_titulo__jO5hx`,
	"iconeTitulo": `styles_iconeTitulo__3uUoz`,
	"iconeTituloPopup": `styles_iconeTituloPopup__QXc8C`,
	"botaoContainer": `styles_botaoContainer__YgqPA`,
	"botaoNovo": `styles_botaoNovo__gcdqR`,
	"tituloPopup": `styles_tituloPopup__H9moY`,
	"tituloPopupContainer": `styles_tituloPopupContainer__iLUrJ`,
	"botoesPopupGeral": `styles_botoesPopupGeral__7mG4c`,
	"botaoPopupSalvar": `styles_botaoPopupSalvar__qzgky`,
	"botaoPopupCancelar": `styles_botaoPopupCancelar__iU0ng`,
	"txtBuscaTabela": `styles_txtBuscaTabela__kgVKm`,
	"iconeBusca": `styles_iconeBusca__5Ux4P`,
	"textoExclusao": `styles_textoExclusao__I0HK2`,
	"tituloExclusao": `styles_tituloExclusao__qOo8P`,
	"botaoPopupExcluir": `styles_botaoPopupExcluir__KwpXp`,
	"botaoPopupCancelarExclusao": `styles_botaoPopupCancelarExclusao__qQEmf`,
	"caixaTextoPequena": `styles_caixaTextoPequena__BY1I7`,
	"caixaDeTexto": `styles_caixaDeTexto__UcJ-W`,
	"botaoVoltar": `styles_botaoVoltar__b-atH`,
	"inputPequeno": `styles_inputPequeno__pQfdC`,
	"labelPequeno": `styles_labelPequeno__tG-G9`,
	"placeholder": `styles_placeholder__9sYhN`,
	"popupHeader": `styles_popupHeader__zJFpk`,
	"popupContent": `styles_popupContent__gxm6T`,
	"pdfContainer": `styles_pdfContainer__ZYhDW`,
	"pdfHeader": `styles_pdfHeader__64deM`,
	"pdfLogo": `styles_pdfLogo__D35j7`,
	"pdfContent": `styles_pdfContent__4eU-8`,
	"pdfTable": `styles_pdfTable__JlZtf`,
	"pdfTotal": `styles_pdfTotal__PnR2x`,
	"pdfFooterTotal": `styles_pdfFooterTotal__PIVcE`,
	"pdfButtons": `styles_pdfButtons__VJwWt`
};
export default ___CSS_LOADER_EXPORT___;
